module.exports = __webpack_public_path__ + "static/img/aiqingcover.015550c2.png";